import { createSelector } from 'reselect';
import { TYPES } from './constants';
import { createLoadingSelector } from '../@loadings';
import { createSuccessSelector } from '../@success';
import { createErrorSelector, createErrorPayloadSelector } from '../@errors';
import { TenantsDataState } from './types';
import { ReduxState } from '../types';

export const selectTenantsData = (state: ReduxState): TenantsDataState => state.tenantsData;
export const selectTenantAdminsData = (state: ReduxState): TenantsDataState => state.tenantsData;
export const selectStorm360AdminsData = (state: ReduxState): TenantsDataState => state.tenantsData;

export const selectTenants = createSelector(selectTenantsData, ({ tenantList }) => tenantList);
export const selectTenant = createSelector(selectTenantsData, ({ tenant }) => tenant);
export const selectTenantAdmins = createSelector(selectTenantAdminsData, ({ tenantAdmins }) => tenantAdmins);
export const selectCurrTenantId = createSelector(selectTenantsData, ({ currTenantId }) => currTenantId.id);
export const selectTenantAdmin = createSelector(selectTenantsData, ({ currTenantAdmin }) => currTenantAdmin);
export const selectStorm360Users = createSelector(selectStorm360AdminsData, ({ storm360Users }) => storm360Users);
export const selectStorm360Admins = createSelector(selectStorm360AdminsData, ({ storm360Admins }) => storm360Admins);
export const selectPendingStorm360Admins = createSelector(selectStorm360AdminsData, ({ pendingStorm360Admins }) => pendingStorm360Admins);
export const selectTenantPendingUsers = createSelector(selectTenantsData, ({ tenantPendingUsers }) => tenantPendingUsers);
export const selectTenantsForSharedUsers = createSelector(selectTenantsData, ({ tenantsForSharedUser }) => tenantsForSharedUser);

export const selectTenantsLoading = createLoadingSelector(TYPES.LOAD_TENANTS.TYPE);
export const selectTenantsSuccess = createSuccessSelector(TYPES.LOAD_TENANTS.TYPE);
export const selectTenantsError = createErrorSelector(TYPES.LOAD_TENANTS.TYPE);

export const selectTenantCreating = createLoadingSelector(TYPES.CREATE_TENANT.TYPE);
export const selectTenantCreatingSuccess = createSuccessSelector(TYPES.CREATE_TENANT.TYPE);
export const selectTenantCreatingErrors = createErrorPayloadSelector(TYPES.CREATE_TENANT.TYPE);

export const selectTenantLoading = createLoadingSelector(TYPES.LOAD_TENANT.TYPE);
export const selectTenantSuccess = createSuccessSelector(TYPES.LOAD_TENANT.TYPE);
export const selectTenantError = createErrorSelector(TYPES.LOAD_TENANT.TYPE);

export const selectTenantUpdating = createLoadingSelector(TYPES.UPDATE_TENANT.TYPE);
export const selectTenantUpdatingSuccess = createSuccessSelector(TYPES.UPDATE_TENANT.TYPE);
export const selectTenantUpdatingErrors = createErrorPayloadSelector(TYPES.UPDATE_TENANT.TYPE);

export const selectTenantDeleting = createLoadingSelector(TYPES.DELETE_TENANT.TYPE);
export const selectTenantDeletingSuccess = createSuccessSelector(TYPES.DELETE_TENANT.TYPE);
export const selectTenantDeletingError = createErrorSelector(TYPES.DELETE_TENANT.TYPE);

export const selectTenantAdminsLoading = createLoadingSelector(TYPES.LOAD_TENANT_ADMINS.TYPE);
export const selectTenantAdminsSuccess = createSuccessSelector(TYPES.LOAD_TENANT_ADMINS.TYPE);
export const selectTenantAdminsError = createErrorSelector(TYPES.LOAD_TENANT_ADMINS.TYPE);

export const selectInviteTenantAdminLoading = createLoadingSelector(TYPES.INVITE_TENANT_ADMIN.TYPE);
export const selectInviteTenantAdminSuccess = createSuccessSelector(TYPES.INVITE_TENANT_ADMIN.TYPE);
export const selectInviteTenantAdminError = createErrorSelector(TYPES.INVITE_TENANT_ADMIN.TYPE);
export const selectInviteTenantAdminErrors = createErrorPayloadSelector(TYPES.INVITE_TENANT_ADMIN.TYPE);

export const selectResendInviteTenantAdminLoading = createLoadingSelector(TYPES.RESEND_INVITE_TENANT_ADMIN.TYPE);
export const selectResendInviteTenantAdminSuccess = createSuccessSelector(TYPES.RESEND_INVITE_TENANT_ADMIN.TYPE);
export const selectResendInviteTenantAdminError = createErrorSelector(TYPES.RESEND_INVITE_TENANT_ADMIN.TYPE);

export const selectTenantAdminDeleteLoading = createLoadingSelector(TYPES.DELETE_TENANT_ADMIN.TYPE);
export const selectTenantAdminDeleteSuccess = createSuccessSelector(TYPES.DELETE_TENANT_ADMIN.TYPE);
export const selectTenantAdminDeleteError = createErrorSelector(TYPES.DELETE_TENANT_ADMIN.TYPE);

export const selectTenantAdminDataLoading = createLoadingSelector(TYPES.LOAD_TENANT_ADMIN_DATA.TYPE);
export const selectTenantAdminDataSuccess = createSuccessSelector(TYPES.LOAD_TENANT_ADMIN_DATA.TYPE);
export const selectTenantAdminDataError = createErrorSelector(TYPES.LOAD_TENANT_ADMIN_DATA.TYPE);

export const selectRegisterTenantAdminLoading = createLoadingSelector(TYPES.REGISTER_TENANT_ADMIN.TYPE);
export const selectRegisterTenantAdminSuccess = createSuccessSelector(TYPES.REGISTER_TENANT_ADMIN.TYPE);
export const selectRegisterTenantAdminError = createErrorSelector(TYPES.REGISTER_TENANT_ADMIN.TYPE);
export const selectRegisterTenantAdminErrors = createErrorPayloadSelector(TYPES.REGISTER_TENANT_ADMIN.TYPE);

export const selectLoadStorm360UsersLoading = createLoadingSelector(TYPES.LOAD_STORM360_USERS.TYPE);
export const selectLoadStorm360UsersSuccess = createSuccessSelector(TYPES.LOAD_STORM360_USERS.TYPE);
export const selectLoadStorm360UsersError = createErrorSelector(TYPES.LOAD_STORM360_USERS.TYPE);
export const selectLoadStorm360UsersErrors = createErrorPayloadSelector(TYPES.LOAD_STORM360_USERS.TYPE);

export const selectLoadStorm360AdminsLoading = createLoadingSelector(TYPES.LOAD_STORM360_ADMINS.TYPE);
export const selectLoadStorm360AdminsSuccess = createSuccessSelector(TYPES.LOAD_STORM360_ADMINS.TYPE);
export const selectLoadStorm360AdminsError = createErrorSelector(TYPES.LOAD_STORM360_ADMINS.TYPE);
export const selectLoadStorm360AdminsErrors = createErrorPayloadSelector(TYPES.LOAD_STORM360_ADMINS.TYPE);

export const selectLoadPendingStorm360AdminsLoading = createLoadingSelector(TYPES.LOAD_PENDING_STORM360_ADMINS.TYPE);
export const selectLoadPendingStorm360AdminsSuccess = createSuccessSelector(TYPES.LOAD_PENDING_STORM360_ADMINS.TYPE);
export const selectLoadPendingStorm360AdminsError = createErrorSelector(TYPES.LOAD_PENDING_STORM360_ADMINS.TYPE);
export const selectLoadPendingStorm360AdminsErrors = createErrorPayloadSelector(TYPES.LOAD_PENDING_STORM360_ADMINS.TYPE);

export const selectDeletePendingStorm360AdminsLoading = createLoadingSelector(TYPES.DELETE_PENDING_STORM360_ADMINS.TYPE);
export const selectDeletePendingStorm360AdminsSuccess = createSuccessSelector(TYPES.DELETE_PENDING_STORM360_ADMINS.TYPE);
export const selectDeletePendingStorm360AdminsError = createErrorSelector(TYPES.DELETE_PENDING_STORM360_ADMINS.TYPE);
export const selectDeletePendingStorm360AdminsErrors = createErrorPayloadSelector(TYPES.DELETE_PENDING_STORM360_ADMINS.TYPE);

export const selectInviteStorm360AdminLoading = createLoadingSelector(TYPES.INVITE_STORM360_ADMIN.TYPE);
export const selectInviteStorm360AdminSuccess = createSuccessSelector(TYPES.INVITE_STORM360_ADMIN.TYPE);
export const selectInviteStorm360AdminError = createErrorSelector(TYPES.INVITE_STORM360_ADMIN.TYPE);
export const selectInviteStorm360AdminErrors = createErrorPayloadSelector(TYPES.INVITE_STORM360_ADMIN.TYPE);

export const selectResendInviteStorm360AdminLoading = createLoadingSelector(TYPES.RESEND_INVITE_STORM360_ADMIN.TYPE);
export const selectResendInviteStorm360AdminSuccess = createSuccessSelector(TYPES.RESEND_INVITE_STORM360_ADMIN.TYPE);
export const selectResendInviteStorm360AdminError = createErrorSelector(TYPES.RESEND_INVITE_STORM360_ADMIN.TYPE);
export const selectResendInviteStorm360AdminErrors = createErrorPayloadSelector(TYPES.RESEND_INVITE_STORM360_ADMIN.TYPE);

export const selectSetTenantUserStatusLoading = createLoadingSelector(TYPES.SET_TENANT_USER_STATUS.TYPE);
export const selectSetTenantUserStatusSuccess = createSuccessSelector(TYPES.SET_TENANT_USER_STATUS.TYPE);
export const selectSetTenantUserStatusError = createErrorSelector(TYPES.SET_TENANT_USER_STATUS.TYPE);
export const selectSetTenantUserStatusErrors = createErrorPayloadSelector(TYPES.SET_TENANT_USER_STATUS.TYPE);

export const selectInviteTenantUserLoading = createLoadingSelector(TYPES.INVITE_TENANT_USER.TYPE);
export const selectInviteTenantUserSuccess = createSuccessSelector(TYPES.INVITE_TENANT_USER.TYPE);
export const selectInviteTenantUserError = createErrorSelector(TYPES.INVITE_TENANT_USER.TYPE);
export const selectInviteTenantUserErrors = createErrorPayloadSelector(TYPES.INVITE_TENANT_USER.TYPE);

export const selectInviteSharedUserLoading = createLoadingSelector(TYPES.INVITE_SHARED_USER.TYPE);
export const selectInviteSharedUserSuccess = createSuccessSelector(TYPES.INVITE_SHARED_USER.TYPE);
export const selectInviteSharedUserError = createErrorSelector(TYPES.INVITE_SHARED_USER.TYPE);
export const selectInviteSharedUserErrors = createErrorPayloadSelector(TYPES.INVITE_SHARED_USER.TYPE);

export const selectRegisterTenantUserLoading = createLoadingSelector(TYPES.REGISTER_TENANT_USER.TYPE);
export const selectRegisterTenantUserSuccess = createSuccessSelector(TYPES.REGISTER_TENANT_USER.TYPE);
export const selectRegisterTenantUserError = createErrorSelector(TYPES.REGISTER_TENANT_USER.TYPE);
export const selectRegisterTenantUserErrors = createErrorPayloadSelector(TYPES.REGISTER_TENANT_USER.TYPE);

export const selectLoadTenantPendingUsersLoading = createLoadingSelector(TYPES.LOAD_TENANT_PENDING_USERS.TYPE);
export const selectLoadTenantPendingUsersSuccess = createSuccessSelector(TYPES.LOAD_TENANT_PENDING_USERS.TYPE);
export const selectLoadTenantPendingUsersError = createErrorSelector(TYPES.LOAD_TENANT_PENDING_USERS.TYPE);
export const selectLoadTenantPendingUsersErrors = createErrorPayloadSelector(TYPES.LOAD_TENANT_PENDING_USERS.TYPE);

export const selectLoadTenantUsersListLoading = createLoadingSelector(TYPES.LOAD_TENANT_USERS_LIST.TYPE);
export const selectLoadTenantUsersListSuccess = createSuccessSelector(TYPES.LOAD_TENANT_USERS_LIST.TYPE);
export const selectLoadTenantUsersListError = createErrorSelector(TYPES.LOAD_TENANT_USERS_LIST.TYPE);
export const selectLoadTenantUsersListErrors = createErrorPayloadSelector(TYPES.LOAD_TENANT_USERS_LIST.TYPE);

export const selectResendInviteTenantUsersLoading = createLoadingSelector(TYPES.RESEND_INVITE_TENANT_USERS.TYPE);
export const selectResendInviteTenantUsersSuccess = createSuccessSelector(TYPES.RESEND_INVITE_TENANT_USERS.TYPE);
export const selectResendInviteTenantUsersError = createErrorSelector(TYPES.RESEND_INVITE_TENANT_USERS.TYPE);

export const selectDeletePendingTenantUsersLoading = createLoadingSelector(TYPES.DELETE_PENDING_TENANT_USERS.TYPE);
export const selectDeletePendingTenantUsersSuccess = createSuccessSelector(TYPES.DELETE_PENDING_TENANT_USERS.TYPE);
export const selectDeletePendingTenantUsersError = createErrorSelector(TYPES.DELETE_PENDING_TENANT_USERS.TYPE);

export const selectTenantsForSharedUserLoading = createLoadingSelector(TYPES.LOAD_TENANTS_FOR_SHARED_USER.TYPE);
export const selectTenantsForSharedUserSuccess = createSuccessSelector(TYPES.LOAD_TENANTS_FOR_SHARED_USER.TYPE);
export const selectTenantsForSharedUserError = createErrorSelector(TYPES.LOAD_TENANTS_FOR_SHARED_USER.TYPE);

export const selectAcceptTenantInviteLoading = createLoadingSelector(TYPES.ACCEPT_TENANT_INVITE.TYPE);
export const selectAcceptTenantInviteSuccess = createSuccessSelector(TYPES.ACCEPT_TENANT_INVITE.TYPE);
export const selectAcceptTenantInviteError = createErrorSelector(TYPES.ACCEPT_TENANT_INVITE.TYPE);

export const selectUploadingTenantLogo = createLoadingSelector(TYPES.UPLOAD_TENANT_LOGO.TYPE);
export const selectSuccessUploadingTenantLogo = createSuccessSelector(TYPES.UPLOAD_TENANT_LOGO.TYPE);
export const selectErrorUploadingTenantLogo = createErrorSelector(TYPES.UPLOAD_TENANT_LOGO.TYPE);

export const selectDeletingTenantLogo = createLoadingSelector(TYPES.DELETE_TENANT_LOGO.TYPE);
export const selectSuccessDeletingTenantLogo = createSuccessSelector(TYPES.DELETE_TENANT_LOGO.TYPE);
export const selectErrorDeletingTenantLogo = createErrorSelector(TYPES.DELETE_TENANT_LOGO.TYPE);
